// const firebase = require("firebase");

// if (process.env.NODE_ENV !== 'production') {
//   console.log('Looks like we are in development mode!');
// }
const devConfig = {
  apiKey: 'AIzaSyDK2lBDUcFJ3lh9z5-ybxlHnxtU9rRGHN8',
  authDomain: 'pkb-app.firebaseapp.com',
  databaseURL: 'https://pkb-app.firebaseio.com',
  projectId: 'pkb-app',
  storageBucket: 'pkb-app.appspot.com',
  messagingSenderId: '1023467017138'
};

const prodConfig = {
    apiKey: "AIzaSyDEQZV8Z2kZZ082uqDaCGiL2OEo1XF9S4Q",
    authDomain: "pkb-pwa.firebaseapp.com",
    databaseURL: "https://pkb-pwa.firebaseio.com",
    projectId: "pkb-pwa",
    storageBucket: "pkb-pwa.appspot.com",
    messagingSenderId: "827731323354"
};

export default {
  dev: devConfig,
  prod: prodConfig
};

  // database: firebaseApp.database(),
  // firebase: firebase



// WEBPACK FOOTER //
// ./src/store/fbconfig.js